/* SilkPearl header — sticky state, mobile drawer, scroll reveals */
(function () {
  'use strict';

  /* ---------- sticky announcement collapse ---------- */
  var root = document.querySelector('.sp-hdr-root');
  if (root) {
    // expose the header's real height so the hero can subtract it
    var publishHeight = function () {
      document.documentElement.style.setProperty('--sp-header-h', root.offsetHeight + 'px');
    };
    publishHeight();
    window.addEventListener('resize', publishHeight, { passive: true });

    var ann = root.querySelector('.sp-ann');
    if (ann) ann.style.height = ann.offsetHeight + 'px';

    var stuck = false;
    var onScroll = function () {
      var next = window.scrollY > 60;
      if (next !== stuck) {
        stuck = next;
        root.classList.toggle('is-stuck', stuck);
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- mobile drawer ---------- */
  var drawer = document.getElementById('sp-drawer');
  var scrim = document.querySelector('.sp-drawer-scrim');
  var openBtn = document.querySelector('[data-sp-drawer-open]');

  if (drawer && scrim && openBtn) {
    var lastFocus = null;

    var focusables = function () {
      return drawer.querySelectorAll('a[href], button:not([disabled])');
    };

    var setDrawer = function (open) {
      if (open) {
        lastFocus = document.activeElement;
        drawer.hidden = false;
        scrim.hidden = false;
        // force a reflow so the transition runs; rAF is paused in background tabs
        void drawer.offsetWidth;
        drawer.classList.add('is-open');
        scrim.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        var f = focusables();
        if (f.length) f[0].focus();
      } else {
        drawer.classList.remove('is-open');
        scrim.classList.remove('is-open');
        document.body.style.overflow = '';
        window.setTimeout(function () {
          drawer.hidden = true;
          scrim.hidden = true;
        }, 380);
        if (lastFocus) lastFocus.focus();
      }
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    openBtn.addEventListener('click', function () {
      setDrawer(true);
    });

    document.querySelectorAll('[data-sp-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        setDrawer(false);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (drawer.hidden) return;
      if (e.key === 'Escape') {
        setDrawer(false);
        return;
      }
      if (e.key !== 'Tab') return;
      // trap focus inside the drawer
      var f = focusables();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  /* ---------- scroll reveals ---------- */
  var reveal = function () {
    var els = document.querySelectorAll('.sp-rv:not(.is-in)');
    if (!els.length) return;

    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !('IntersectionObserver' in window)
    ) {
      els.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }
    );

    els.forEach(function (el) {
      io.observe(el);
    });
  };

  reveal();
  // re-scan when the theme editor swaps a section in
  document.addEventListener('shopify:section:load', reveal);
})();
